const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRfidCards(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 22 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsSerif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.226802,0,0,0.226802,-0.39713,-0.298471)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M69.184,40.862C69.184,42.495 70.508,43.819 72.141,43.819C73.774,43.819 75.098,42.495 75.098,40.862C75.098,32.048 67.953,24.904 59.14,24.904C57.506,24.904 56.184,26.228 56.184,27.861C56.184,29.494 57.506,30.818 59.14,30.818C64.688,30.817 69.184,35.314 69.184,40.862Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.14,1.25C57.506,1.25 56.184,2.574 56.184,4.207C56.184,5.84 57.506,7.164 59.14,7.164C77.75,7.164 92.838,22.25 92.838,40.862C92.838,42.495 94.161,43.819 95.795,43.819C97.427,43.819 98.752,42.495 98.752,40.862C98.752,18.985 81.016,1.25 59.14,1.25Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.862,53.33C78.228,53.33 76.905,54.654 76.905,56.288L76.905,80.644C76.905,87.175 71.61,92.47 65.078,92.47L19.491,92.47C12.959,92.47 7.664,87.175 7.664,80.644L7.664,35.057C7.664,28.525 12.959,23.23 19.491,23.23L43.667,23.23C45.3,23.23 46.624,21.906 46.624,20.273C46.624,18.64 45.3,17.315 43.667,17.315L19.491,17.315C9.694,17.315 1.751,25.258 1.751,35.056L1.751,80.643C1.751,90.441 9.694,98.383 19.491,98.383L65.078,98.383C74.876,98.383 82.819,90.441 82.819,80.643L82.819,56.287C82.819,54.654 81.494,53.33 79.862,53.33Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 59.14,
    cy: 40.862,
    r: 4.131,
    style: {
      fill: "white"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.14,13.077C57.506,13.077 56.184,14.401 56.184,16.034C56.184,17.667 57.506,18.991 59.14,18.991C71.219,18.991 81.011,28.783 81.011,40.863C81.011,42.496 82.335,43.82 83.968,43.82C85.601,43.82 86.925,42.496 86.925,40.863C86.925,25.517 74.484,13.077 59.14,13.077Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.099,51.648L32.099,64.052C32.099,66.248 33.886,68.036 36.082,68.036L48.487,68.036C50.683,68.036 52.471,66.248 52.471,64.052L52.471,60.807L66.105,60.807L66.105,66.565C61.069,71.601 56.035,76.636 51,81.67L18.464,81.67L18.464,34.031L43.668,34.031C45.301,34.031 46.625,32.707 46.625,31.074C46.625,29.441 45.301,28.117 43.668,28.117L18.464,28.117C15.199,28.117 12.551,30.764 12.551,34.031L12.551,81.67C12.551,84.937 15.198,87.584 18.464,87.584L51,87.584C52.729,87.584 53.958,87.075 55.181,85.853C60.217,80.818 65.251,75.782 70.286,70.747C71.51,69.524 72.018,68.296 72.018,66.566L72.018,60.808C72.018,57.541 69.37,54.894 66.104,54.894L52.47,54.894L52.47,51.649C52.47,49.453 50.682,47.666 48.486,47.666L36.082,47.666C33.886,47.665 32.099,49.452 32.099,51.648Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRfidCards);
export default __webpack_public_path__ + "static/media/rfid-cards.ecd6a23c521fe47ac7c40e69bb08d16e.svg";
export { ForwardRef as ReactComponent };